<template>
  <div>
    <div class="maf-loading" v-show="isPlaidLoading">
      <div class="spinner">
        <svg-icon :name="'lc-logo'" :width="115" :height="114"></svg-icon>
      </div>
      <div class="waiting-tip" style="display: none;">
        <div>We are verifying your information,</div>
        <div>which may take up to 5 minutes.</div>
        <div>Please do not close this window.</div>
      </div>
    </div>
    <cover v-model="isPlaidCover"/>
    <div>
      <div v-show="isShowAccountNumber" style="margin-bottom: 10px;margin-top: 10px;color: #878787;font-size: 16px;">
        The bank account we will use for payments is <p class="notranslate" style="display: inline;">{{ accountNumberMask }}.</p> Use the "Change bank account" option below if your account has changed.
      </div>
      <button class="PlaidBtn" @click.stop="confirmPlaidVerification" :disabled="btnDisabled" v-html="btnName"></button>
    </div>

    <div v-show="alerting">
      <div class="maf-mask open" style=""></div>
      <div class="maf-alert open plaid-alert-popup" style="">
        <div v-show="closePopup" class="close-popup" tabindex="0" @keydown.enter.space.stop="clearPopup()" @click="clearPopup()" style="outline: none; cursor: pointer;">
          <svg-icon :name="'closed-popup'" :width="15" :height="15"></svg-icon>
        </div>
        <p class="title" style="padding-top: 20px;">{{ msg }}</p>
        <p class="content" v-html="content"></p>
        <div style="margin-top: 20px;">
          <div class="bth-group">
            <maf-button class="button" v-if="showPlaidConfirm" :name="'Cancel'" :width="btnWidth" :fontSize="btnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="clearPopup()"/>
            <maf-button class="button" v-if="showPlaidConfirm" data-a11y-first="true" :name="'Confirm'" :width="btnWidth" :fontSize="btnFont" @actionFunc="confirmPlaid()"/>
          </div>
          <div class="bth-group-vertically">
            <maf-button class="button" v-if="nameNotMatch" :name="'Verify manually'" :width="btnWidthVertically" :fontSize="btnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="manualVerification()"/>
            <maf-button class="button" v-if="nameNotMatch" data-a11y-first="true" :name="'Try again with Plaid'" :width="btnWidthVertically" :fontSize="btnFont" @actionFunc="reAuthentication()"/>
            <maf-button class="button" v-if="openPlaid" data-a11y-first="true" :name="'OK, open Plaid verification'" :width="btnWidthVertically" :fontSize="btnFont" @actionFunc="oAuthPlaid()"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Auth -->
    <div v-show="showAccountNumber">
      <div class="maf-mask open" style=""></div>
      <div class="maf-alert maf-actions plaid-auth-popup">
        <p class="title" style="padding-top: 20px;padding-bottom: 10px;margin-bottom: 0px;">Please choose your Account Number:</p>
        <div class="content" style="margin-top: 21px;margin-left: 25px;text-align: left;">
            <maf-input class="notranslate" ref="" name="" width="210" height="50" v-model="achAccountId" type="select" :required="true"
                :options="accountNumberOptions"></maf-input>
        </div>
        <div :style="{'margin-top': '30px'}">
          <maf-button class="button" :disabled="!achAccountId" data-a11y-first="true" name="Confirm" :width="btnWidth" :fontSize="btnFont" @actionFunc="accountNumberConfirm()"/>
        </div>
      </div>
    </div>

    <!-- isManualValid -->
    <div v-show="isManualValid" class="manual-popup">
      <div class="maf-mask open" style=""></div>
      <div class="manual-valid plaid-manual-frame" ref="manualValid" id="manualValid">
        <checking-account ref="checkingAccount" :appId="appId" :loanIndex="loanIndex" :loanId="loanId" @update="handleUpdate" @updateIsManualValid="handleUpdateIsManualValid"></checking-account>
      </div>
    </div>

    <div v-show="isShowCheckingAccountPopup">
      <div class="maf-mask open"></div>
      <div class="maf-alert open plaid-sub-popup">
        <div v-show="checkingAccountPopup.showCancelSubmit" class="close-popup" tabindex="0" @keydown.enter.space.stop="clearCheckingAccountPopup()" @click="clearCheckingAccountPopup()" style="outline: none; cursor: pointer;">
          <svg-icon :name="'closed-popup'" :width="15" :height="15"></svg-icon>
        </div>
        <p class="title" style="padding-top: 20px;padding-bottom: 10px;margin-bottom: 0px;">{{ checkingAccountPopup.msg }}</p>
        <p class="content" v-html="checkingAccountPopup.content"></p>
        <div style="margin-top: 20px;margin-bottom: 40px;">
          <div style="align-items: center;display: flex;flex-direction: column;gap: 20px;">
            <maf-button class="button" v-if="checkingAccountPopup.showCancelSubmit" :name="'Exit form'" :width="btnWidthVertically" :fontSize="btnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="confirmCancelInPopup()"/>
            <maf-button class="button" v-if="checkingAccountPopup.showCancelSubmit" data-a11y-first="true" :name="'Continue working'" :width="btnWidthVertically" :fontSize="btnFont" @actionFunc="clearCheckingAccountPopup()"/>
            <maf-button class="button" v-if="checkingAccountPopup.showConfirmSubmit" data-a11y-first="true" :name="'OK'" :width="btnWidth" :fontSize="btnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="submitInPopup()"/>
            <maf-button class="button" v-if="checkingAccountPopup.isShowErrorPopup" data-a11y-first="true" :name="'OK'" :width="btnWidth" :fontSize="btnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="clearCheckingAccountPopup()"/>
          </div>
        </div>
      </div>
   </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import MafButton from './MafButton.vue';
import CheckingAccount from './CheckingAccount.vue';
import { getPlaidLinkToken, autoVerifyPlaidInfo, getAuth, submitPlaidInfo, getViewLoansRemoting } from '../../api';

export default {
  components: { MafButton, CheckingAccount },
  props: {
    btnDisabled: Boolean,
    btnName: String,
    appId: String,
    loanIndex: Number,
    loanId: String,
    accountNumberMask: String,
    isShowAccountNumber: Boolean
  },
  data() {
    return {
      plaid: null,
      linkHandler: null,
      plaidLinkToken: '',
      plaidEnv: '',
      institution_id: '',
      institution_name: '',
      isValid: false,
      isPlaidCover: false,
      isPlaidLoading: false,
      alerting: false,
      nameNotMatch: false,
      showAccountNumber: false,
      showPlaidConfirm: false,
      isManualValid: false,
      isShowCheckingAccountPopup: false,
      closePopup: false,
      openPlaid: false,
      msg: '',
      content: '',
      numbersACH: [],
      accountNumber: '',
      rountingNumber: '',
      chaseAccountNumberMask: '',
      accountNumberOptions: [{ label: 'Select an option', value: '' }],
      plaidClientId: '',
      allAccountOwnerNames: '',
      calloutRequestTimes: 0,
      MAX_CALLOUT_LIMIT: 10,
      achAccountId: '',
      plaidConfig: {
        user: {
          client_user_id: '',
        },
        client_name: 'Plaid Quickstart',
        products: ['auth', 'identity', 'assets', 'identity_match'],
        language: 'en',
        country_codes: ['US'],
        link_customization_name: '',
      },
      checkingAccountPopup: {
        msg: '',
        content: '',
        showCancelSubmit: false,
        showConfirmSubmit: false,
        isShowErrorPopup: false,
        alerting: false
      },
    }
  },
  watch: {
    alerting: function(newVal) {
      if (newVal === true) {
        this.$nextTick(function() {
          if (this.$A11yFocus) this.$A11yFocus.lock('.plaid-alert-popup', '[data-a11y-first="true"]');
        });
      } else {
        if (this.$A11yFocus) this.$A11yFocus.unlock();
      }
    },

    showAccountNumber: function(newVal) {
      if (newVal === true) {
        this.$nextTick(function() {
          if (this.$A11yFocus) this.$A11yFocus.lock('.plaid-auth-popup', '[data-a11y-first="true"]');
        });
      } else {
        if (this.$A11yFocus) this.$A11yFocus.unlock();
      }
    },

    isManualValid: function(newVal) {
      if (newVal === true) {
        this.$nextTick(function() {
          let frame = document.querySelector('.plaid-manual-frame');
          if (frame) {
            frame.setAttribute('tabindex', '-1');
            frame.focus();
          }
        });
      } else {
        if (this.$A11yFocus) this.$A11yFocus.unlock();
      }
    },

    isShowCheckingAccountPopup: function(newVal) {
      if (newVal === true) {
        this.$nextTick(function() {
          if (this.$A11yFocus) this.$A11yFocus.lock('.plaid-sub-popup', '[data-a11y-first="true"]');
        });
      } else {
        this.$nextTick(function() {
          if (this.isManualValid) {
            let frame = document.querySelector('.plaid-manual-frame');
            if (frame) frame.focus();
          } else {
            if (this.$A11yFocus) this.$A11yFocus.unlock();
          }
        });
      }
    }
  },
  beforeDestroy() {
    if (this.$A11yFocus && typeof this.$A11yFocus.unlock === 'function') {
      this.$A11yFocus.unlock();
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.isLoading,
      userInfo: state => state.userInfo,
      isMobile: state => state.isMobile,
    }),
    btnWidth() {
      return 200;
    },
    btnWidthVertically() {
      return 260;
    },
    btnFont() {
      if (this.isMobile) {
        return 14;
      }
      return 16;
    },
  },
  methods: {
    createPlaid() {
      let self = this;
      this.isPlaidCover = false;
      this.isValid = true;
      if (this.plaid != null) {
        if (this.linkHandler != null) {
          this.linkHandler.destroy();
          this.linkHandler = null;
        }
        this.linkHandler = this.plaid.create({
          clientName: this.plaidConfig.client_name,
          env: this.plaidEnv,
          product: this.plaidConfig.products,
          token: this.plaidLinkToken,
          onLoad: function() {},
          onSuccess: function(publicToken, metadata) {
            const institution = metadata.institution;

            if (institution) {
              self.institution_id = institution.institution_id || '';
              self.institution_name = institution.name || '';
            } else {
              self.institution_id = '';
              self.institution_name = '';
            }

            if (publicToken) {
              self.autoAuth(publicToken);
            }
          },
          onExit: function(err, metadata) {
            if (err != null && err.error_code === 'INVALID_LINK_TOKEN') {
              if (self.linkHandler) {
                self.linkHandler.destroy();
              }
              let newRes = self.fetchLinkToken();
              self.setLinkToken(newRes);
              self.createPlaid();
            } else {
              self.exitPlaid();
            }
            this.openPlaidStatus = false
          },
          onEvent: function(eventName, metadata) {
            if (eventName === 'ERROR') {
              self.exitPlaid();
            }
            if (eventName === 'ERROR' && (metadata.error_code === 'INVALID_MFA'
                || metadata.error_code === 'INSTITUTION_NOT_RESPONDING'
                || metadata.error_code === 'MFA_NOT_SUPPORTED'
                || metadata.error_code === 'INSTITUTION_DOWN'
                || metadata.error_code === 'INSTITUTION_NOT_AVAILABLE'
                || metadata.error_code === 'ITEM_LOCKED'
                || metadata.error_code === 'ITEM_LOGIN_REQUIRED'
                || metadata.error_code === 'ITEM_NOT_SUPPORTED'
                || metadata.error_code === 'INVALID_SEND_METHOD'
                || metadata.error_code === 'INTERNAL_SERVER_ERROR'
                || metadata.error_code === 'PLANNED_MAINTENANCE'
                || metadata.error_code === 'RATE_LIMIT'
            )) {
              this.isValid = false;
              self.exitPlaid();
            }
          },
        });
        if (this.isValid) {
          this.linkHandler.open();
        }
      }
    },
    async oAuthPlaid() {
      this.openPlaidStatus = true
      this.clearPopup();
      this.isPlaidCover = true;
      try {
        const localNCAPlaidLinkTokenObj = JSON.parse(window.localStorage.getItem('localNCAPlaidLinkTokenObj'));
        const currentLanguage = window.localStorage.getItem('wglang');
        let languageChange = this.plaidConfig.language !== currentLanguage;
        this.plaidConfig.language = currentLanguage === 'es' ? 'es' : 'en';
        this.plaidConfig.link_customization_name = currentLanguage === 'es' ? 'spanish_plaid_link' : '';
        this.plaidConfig.user.client_user_id = this.userInfo.userId;
        let newRes;
        if (localNCAPlaidLinkTokenObj && !languageChange) {
          if (new Date() > new Date(localNCAPlaidLinkTokenObj.expiration)) { // 过期
            newRes = await this.fetchLinkToken()
          } else {
            newRes = localNCAPlaidLinkTokenObj;
          }
        } else {
          newRes = await this.fetchLinkToken()
        }
        this.setLinkToken(newRes);
        this.$nextTick(() => {
          this.createPlaid();
        })
      } catch (error) {
        console.error(error);
        this.openPlaidStatus = false
      }
    },
    async fetchLinkToken() {
      const res = await getPlaidLinkToken(JSON.stringify(this.plaidConfig), this.userInfo.userId)
      const newRes = JSON.parse(res.replaceAll('&quot;', '"'))
      window.localStorage.setItem('localNCAPlaidLinkTokenObj', JSON.stringify(newRes))
      return newRes
    },
    setLinkToken(newRes) {
      if (newRes) {
        this.plaidLinkToken = newRes.link_token;
        this.plaidEnv = newRes.link_token.split('-')[1];
      }
    },
    autoAuth(publicToken) {
      this.$store.state.isLoading = true;
      self.isPlaidCover = true;

      let clientConfig = {
        appId: this.appId,
        firstName: this.userInfo.firstName,
        lastName: this.userInfo.lastName,
        publicToken: publicToken,
        institutionId: this.institution_id,
        institutionName: this.institution_name
      }
      this.autoVerifyPlaidInfo(clientConfig);
    },
    async autoVerifyPlaidInfo(clientConfig) {
      const res = await autoVerifyPlaidInfo(JSON.stringify(clientConfig), this.userInfo.userId);
      const warpers = JSON.parse(res.replaceAll('&quot;', '"'));
      if (warpers.code === 'SUCCESS') {
        this.plaidClientId = warpers.message;
        this.allAccountOwnerNames = warpers.names;
        // Get Auth
        this.isPlaidLoading = true;
        await this.getAuth(clientConfig.institutionName, this.userInfo.contactId);
        this.isPlaidLoading = false;
      } else if (warpers.code === 'NAME_NOT_MATCH') { // The firstName or lastName not matchs
        this.exitPlaid();
      } else {
        this.isPlaidCover = false;
      }
      this.$store.state.isLoading = false;
    },
    async getAuth(institutionName, contactId) {
      let self = this;
      const res = await getAuth(institutionName, this.userInfo.userId);
      const authWrapper = JSON.parse(res.replaceAll('&quot;', '"'));
      if (authWrapper.failed || authWrapper.hasChecking === false) {
        this.clearPopup();
        this.noCheckingAccount();
      } else {
        this.clearPopup();
        self.numbersACH = authWrapper.aches;
        self.numbersACH.forEach((item, index, array) => {
          self.accountNumberOptions.push({
            label: item.mask,
            value: item.account_id
          })
        })
        this.showAccountNumber = true;
      }
    },
    noCheckingAccount() {
      this.alerting = true;
      this.msg = 'Looks like you didn’t connect a checking account';
      this.content = `<span>If you do have a checking account, try verifying again and be sure to select this account.<br><br>If you do not have one, please reach out to MAF at <a class="notranslate" href="mailto:programs@missionassetfund.org">programs@missionassetfund.org</a>.</span>`;
      this.nameNotMatch = true;
      this.closePopup = true;
    },
    async confirmPlaidVerification() {
      await getViewLoansRemoting(this.userInfo.userId);
      this.alerting = true;
      this.msg = 'Verify the bank account you would like to use on your loan';
      this.content = `<span><span style="color: black;">Please try verifying with Plaid first</span>, as we will be able to process your request much faster and accurately.<br><br>If you discover Plaid is not possible for you, you can always close the pop-up and proceed to verify manually.</span>`;
      this.openPlaid = true;
      this.closePopup = true;
    },
    reAuthentication() {
      this.calloutRequestTimes = 0;
      this.accountNumberOptions = [];
      this.numbersACH = [];
      this.alerting = false;
      this.msg = '';
      this.content = '';
      this.clearPopup();
      this.oAuthPlaid();
    },
    manualVerification() {
      this.clearPopup();
      this.isManualValid = true;
      this.$nextTick(() => {
        document.getElementById('manualValid').scrollTop = 0;
      })
    },
    clearPopup() {
      this.alerting = false;
      this.msg = '';
      this.content = '';
      this.accountNumberOptions = [];
      this.numbersACH = [];
      this.nameNotMatch = false;
      this.showPlaidConfirm = false;
      this.isManualValid = false;
      this.closePopup = false;
      this.openPlaid = false;
    },
    accountNumberConfirm() {
      this.showAccountNumber = false
      this.numbersACH.forEach((item, index, array) => {
        if (this.achAccountId === item.account_id) {
          this.accountNumber = item.account
          this.rountingNumber = item.routing;
          if (item.mask) {
            if (this.institution_name === 'Chase') {
              this.chaseAccountNumberMask = item.mask.substring(item.mask.length - 4);
            } else {
              this.chaseAccountNumberMask = '';
            }
          }
        }
      })
      let lastAccountFourChars = this.institution_name === 'Chase' ? this.chaseAccountNumberMask : this.accountNumber.substring(this.accountNumber.length - 4);
      this.alerting = true;
      this.msg = 'Confirm change of bank account';
      this.content = `</span>By confirming, you agree to update your bank account information for payments and disbursements to the account ending in <p class="notranslate" style="display: inline;"> ${lastAccountFourChars}.</p> <br><br> This change will go into effect within <strong>5-7 business days</strong>. <br><br> If your next payment is scheduled sooner than 5-7 business days, the account currently connected will be debited. If the account currently connected does not have sufficient funds or is not available for use, please contact us at <a class="notranslate" href="mailto:programs@missionassetfund.org">programs@missionassetfund.org</a>.</span>`;
      this.showPlaidConfirm = true;
    },
    async confirmPlaid() {
      this.clearPopup();
      this.isPlaidCover = true;
      let plaidInfo = {
        appId: this.appId,
        accountNumber: this.accountNumber,
        rountingNumber: this.rountingNumber,
        institutionName: this.institution_name,
        loanId: this.loanId,
        typeOfBank: 'Not Required',
        chaseAccountNumberMask: this.chaseAccountNumberMask,
        allAccountOwnerNames: this.allAccountOwnerNames,
      }
      await submitPlaidInfo(JSON.stringify(plaidInfo), this.userInfo.userId);
      this.isPlaidCover = false;
      this.achAccountId = '';
      this.updateButtonStatus('Plaid');
    },
    updateButtonStatus(method) {
      this.$store.state.dashboardHomeData.program.activeProgram.viewLoans[this.loanIndex].isUpdateButtonPending = true;
      this.$store.state.dashboardHomeData.program.activeProgram.viewLoans[this.loanIndex].verificationMethod = method;
      this.btnDisabled = true;
    },
    handleUpdate(value) {
      this.clearPopup();
    },
    exitPlaid() {
      this.linkHandler.exit({ force: true });
      this.alerting = true;
      this.nameNotMatch = true;
      this.closePopup = true;
      this.msg = 'Unable to connect this account';
      this.content = '<span>It looks like you aren’t able to connect your bank account with Plaid. Please ensure that the name on the account you provide matches the name on your loan.<br><br>You can try again or verify manually using a voided check or bank statement.</span>';
    },
    handleUpdateIsManualValid(checkingAccountPopup) {
      this.$nextTick(() => {
        this.checkingAccountPopup = checkingAccountPopup;
        if (checkingAccountPopup.alerting) {
          this.$refs.manualValid.style.overflow = 'hidden'
          this.isShowCheckingAccountPopup = true;
        } else {
          this.$refs.manualValid.style.overflow = 'auto'
          this.isShowCheckingAccountPopup = false;
        }
      });
    },
    confirmCancelInPopup() {
      this.$refs.checkingAccount.confirmCancel();
      this.clearPopup();
    },
    clearCheckingAccountPopup() {
      this.$refs.checkingAccount.clearPopup();
    },
    submitInPopup() {
      this.$refs.checkingAccount.submit();
      this.clearPopup();
    },
  },
  mounted() {
    if (window.Plaid) {
      this.plaid = window.Plaid
      return
    }

    let linkScript = document.createElement('script')
    linkScript.async = true
    linkScript.setAttribute('src', 'https://cdn.plaid.com/link/v2/stable/link-initialize.js')
    document.head.appendChild(linkScript)

    linkScript.onload = () => {
      this.plaid = window.Plaid
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import './../../sass/main.scss';
.PlaidBtn{
  @include inline-flex-row;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  transition: background-color 200ms linear;
  border: 0;
  // width: 247px;
  height: 39px;
  font-size: 16px;
  background: -webkit-linear-gradient(left top, #3023AE, #C86DD7);
  display: inline-block;
  padding: 0 20px;
  width: 250px;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    color: #878787 !important;;
    background: #e8eaec !important;;
    cursor: default;
    border: 0;
  }
}

.maf-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.51;
  background: #44546a;
  display: none;
}

.maf-mask.open {
  display: block;
}

.maf-alert {
  display: none;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 300px;
  padding: 30px;
  background: #fefefe;
  box-shadow: 0 2px 10px 0 rgba(138, 138, 138, 0.5);
  border-radius: 7px;
  text-align: center;
  margin-top: 50px;

  .close-popup {
    position: absolute;
    top: 20px;
    right: 20px;

    @media screen and (max-width: $max-width-phone) {
      top: 10px;
      right: 10px;
    }
  }
}

.maf-alert.open {
  display: block;
  min-width: 420px;
  max-height: 550px;
  overflow: scroll;
}

.maf-alert.maf-actions{
  display: block;
}

.manual-valid{
  display: block;
  width: auto;
  max-width: 900px;
  height: 80%;
  overflow: auto;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  padding: 60px;
  background: #fefefe;
  border-radius: 7px;
}

.maf-alert .title {
  font-family: San Francisco Weight;
  font-size: 20px;
  color: #834bc4;
  letter-spacing: 0.21px;
  text-align: center;
}

.maf-alert .content {
  margin: 20px 0;
  font-size: 16px;
  color: #393c40;
  letter-spacing: 0;
  text-align: center;
  line-height: 23px;
}

.maf-alert .maf-button.purple ~ .maf-button {
  margin-left: 50px;
}

.main .title {
  text-transform: unset;
}

.maf-button {
  color: #fff;
  border: none;
  border-radius: 100px;
  font-size: 16px;
  padding: 9px 10px;
  min-width: 150px;
  background-repeat: no-repeat;
  outline: none;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
}

.maf-button.disabled {
  position: relative;
  display: inline-block;
  min-width: 100px;
  padding-left: 20px;
  padding-right: 15px;
  color: #878787 !important;
  background: #E8EAEC !important;
  cursor: not-allowed !important;
}

.maf-button.purple {
  background-image: linear-gradient(134deg, #3023AE 0%, #C86DD7 100%);
}

.maf-alert .maf-button.purple ~ .maf-button {
  margin-left: 50px;
}

.maf-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(90deg, #432CB3 0%, #1DC4E9 100%);
  z-index: 99999999;

  .spinner {
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
  }

  .spinner svg {
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .icon {
    animation: scroll 2s infinite linear;
  }

  .waiting-tip {
    position: absolute;
    top: 64%;
    transform: translate(-50%, -50%);
    left: 50%;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-family: SFProText-Semibold;
    font-size: 25px;
    color: #FFFFFF;
    letter-spacing: 0.61px;
    text-align: center;
  }
}

.bth-group {
  align-items: center;
  display: flex;
  gap: 20px;
  flex-direction: unset;
}

.bth-group-vertically {
  align-items: center;
  display: flex;
  gap: 20px;
  flex-direction: column-reverse;
}

@media screen and (max-width: 768px), screen and (max-width: 950px) and (max-height: 500px) {
  .maf-alert {
    padding: 20px;
    width: calc(100% - 80px);
  }

  .maf-alert.open {
    min-width: unset;
  }

  .maf-alert .maf-button {
    width: 80%;
  }

  .PlaidBtn {
    width: 100%;
  }

  .maf-alert .maf-button.purple ~ .maf-button {
    margin-top: 10px;
    margin-left: 0;
  }

  .maf-alert .maf-button {
    width: 80%;
  }

  .maf-alert .maf-button.purple ~ .maf-button {
    margin-top: 10px;
    margin-left: 0;
  }

  .manual-valid {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    padding: 100px 30px 30px 30px;
    background: #fefefe;
    border-radius: 7px;
  }

  .bth-group {
    flex-direction: column-reverse;
  }

  .maf-alert.maf-actions{
    flex-direction: column;
  }

  .maf-btn {
    width: 100% !important;
  }
}

@media screen and (max-height: 500px) {
  .maf-alert.open {
    max-height: 270px;
    overflow: scroll;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PlaidLink.vue